import { useQuery } from "react-query"
import { get_matching } from "../../services/timesheet";


const useMatchDetail = (filters) => {

    return useQuery(['get_match_detail', filters], ()=>get_matching(filters))
}

export default useMatchDetail;